// extracted by mini-css-extract-plugin
module.exports = {"container":"Note_container__1lTTx"};